
import { AdvancedFind } from './AdvancedFind';
export class RowSearchStrategy extends AdvancedFind {
    constructor(dependencyGraph) {
        super(dependencyGraph);
        this.dependencyGraph = dependencyGraph;
    }
    /*
     * WARNING: Finding lower/upper bounds in unordered ranges is not supported. When ordering === 'none', assumes matchExactly === true
     */
    find(searchKey, rangeValue, searchOptions) {
        return this.basicFind(searchKey, rangeValue, 'col', searchOptions);
    }
}
